var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87024 0.537434L6.00335 4.64693L10.1365 0.537434C10.4106 0.264866 10.8534 0.264866 11.1276 0.537434C11.4017 0.810003 11.4017 1.25031 11.1276 1.52287L6.49539 6.12858C6.22125 6.40115 5.77842 6.40115 5.50429 6.12858L0.872105 1.52287C0.59797 1.25031 0.59797 0.810003 0.872105 0.537434C1.14624 0.271855 1.5961 0.264866 1.87024 0.537434Z",
    fill: "#1A9CC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlue);
export default __webpack_public_path__ + "static/media/arrowBlue.b3a4851eb56d0f46ba9bd08f45e01e63.svg";
export { ForwardRef as ReactComponent };